(function($) {
  var allowedHashes = ['#lower-priced-options'];
  var scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
  var hash;

  if (location.hash && allowedHashes.includes(location.hash) && scrollPos === 0 && $(location.hash).length > 0) {
    hash = location.hash;
    location.hash = '';
  }

  $(window).load(function() {
    if (hash && scrollPos === 0 && $(hash).length > 0) {
      $('html, body').animate({
        scrollTop: $(hash).offset().top + 'px'
      }, 1000, 'swing');

      location.hash = hash;
    }
  });
})(jQuery);
